// extracted by mini-css-extract-plugin
export default {"container":"FootResp_container__vnm+t","redes":"FootResp_redes__YO4kM","wap":"FootResp_wap__-+Lcr","fac":"FootResp_fac__Aqpz8","ing":"FootResp_ing__juXYP"};